export default __webpack_public_path__ + "static/media/os_debian.f006822f.svg";